export function transformNumberToFixedDecimals(number, decimalSize=2){
    return parseFloat(number).toFixed(decimalSize);
}

export function transformNumberToInteger(number){
    return parseInt(number);
}


export function convertPersianOrArabicNumbersToEnglishInTheString(str) {
    if (!str) return str;
    
    const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    
    return str.split('').map(char => {
        // Check for Persian numbers
        const persianIndex = persianNumbers.indexOf(char);
        if (persianIndex !== -1) return persianIndex.toString();
        
        // Check for Arabic numbers
        const arabicIndex = arabicNumbers.indexOf(char);
        if (arabicIndex !== -1) return arabicIndex.toString();
        
        // Return original character if not a number
        return char;
    }).join('');
}

export const ceilToNearestPowerOfTen = (number, n=3) => {
    number = Number(number)
  // Calculate the multiplier: 10^n
  const multiplier = Math.pow(10, n);
  return Math.ceil(number / multiplier) * multiplier;
};


export const roundUp = (number, n=3) => {
    number = Number(number)
  // Calculate the multiplier: 10^n
  const multiplier = Math.pow(10, n);
  return Math.ceil(number * multiplier) / multiplier;
};

export const roundDown = (number, n=3) => {
    number = Number(number)
    const multiplier = Math.pow(10, n);
    return Math.floor(number * multiplier) / multiplier;
};